var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightRecurringPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.325 26.7835C26.0664 26.7835 25.8184 26.8864 25.6356 27.0694C25.4527 27.2525 25.35 27.5008 25.35 27.7598C25.35 28.0187 25.4527 28.267 25.6356 28.4501C25.8184 28.6332 26.0664 28.7361 26.325 28.7361H30.225C30.4836 28.7361 30.7316 28.6332 30.9145 28.4501C31.0973 28.267 31.2 28.0187 31.2 27.7598C31.2 27.5008 31.0973 27.2525 30.9145 27.0694C30.7316 26.8864 30.4836 26.7835 30.225 26.7835H26.325ZM3.90002 14.58C3.90002 13.1559 4.465 11.7901 5.47066 10.7832C6.47633 9.77617 7.8403 9.21045 9.26252 9.21045H29.7375C31.1597 9.21045 32.5237 9.77617 33.5294 10.7832C34.535 11.7901 35.1 13.1559 35.1 14.58V27.2716C35.1 28.6957 34.535 30.0615 33.5294 31.0685C32.5237 32.0755 31.1597 32.6412 29.7375 32.6412H9.26252C7.8403 32.6412 6.47633 32.0755 5.47066 31.0685C4.465 30.0615 3.90002 28.6957 3.90002 27.2716V14.58ZM9.26252 11.163C8.35747 11.163 7.48949 11.523 6.84952 12.1638C6.20955 12.8046 5.85002 13.6738 5.85002 14.58V17.0207H33.15V14.58C33.15 13.6738 32.7905 12.8046 32.1505 12.1638C31.5106 11.523 30.6426 11.163 29.7375 11.163H9.26252ZM33.15 18.9733H5.85002V27.2716C5.85002 29.1578 7.37882 30.6886 9.26252 30.6886H29.7375C30.6426 30.6886 31.5106 30.3286 32.1505 29.6878C32.7905 29.047 33.15 28.1779 33.15 27.2716V18.9733Z",
    fill: "url(#paint0_linear_4485_421)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.0562 10.3429H8.95562C7.59942 10.3429 6.5 11.4716 6.5 12.8639V27.9895C6.5 29.3818 7.59942 30.5104 8.95562 30.5104H31.0562C32.4124 30.5104 33.5119 29.3818 33.5119 27.9895V12.8639C33.5119 11.4716 32.4124 10.3429 31.0562 10.3429Z",
    fill: "url(#paint1_linear_4485_421)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4485_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0834 24.0737V24.5C24.0828 25.4883 23.7627 26.45 23.171 27.2417C22.5792 28.0333 21.7474 28.6124 20.7996 28.8926C19.8518 29.1728 18.8388 29.1392 17.9117 28.7967C16.9845 28.4542 16.193 27.8211 15.655 26.992C15.1171 26.1628 14.8616 25.182 14.9266 24.1958C14.9917 23.2096 15.3737 22.2708 16.0159 21.5195C16.6581 20.7682 17.5259 20.2445 18.4899 20.0267C19.454 19.8089 20.4626 19.9086 21.3654 20.3108",
    stroke: "url(#paint2_linear_4485_421)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.895 22.106L19.1471 25.8539L18.125 24.8317",
    stroke: "url(#paint3_linear_4485_421)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4485_421",
    x1: 3.90002,
    y1: 22.8357,
    x2: 32.7145,
    y2: 10.3108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4485_421",
    x1: 6.5,
    y1: 22.0706,
    x2: 31.4001,
    y2: 11.1839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4485_421",
    x1: 24.2076,
    y1: 18.1134,
    x2: 16.7557,
    y2: 18.4562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4485_421",
    x1: 22.9597,
    y1: 21.3698,
    x2: 19.087,
    y2: 21.5965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(14 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRecurringPayment);
export default __webpack_public_path__ + "static/media/lightRecurringPayment.0e5add9374a3a7503e32d32c05caf6fb.svg";
export { ForwardRef as ReactComponent };